
import React, {useCallback, useEffect, useState} from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import View1 from "../package/View1";
import View2 from "../package/View2";
import View3 from "../package/view3";
import ProductContainer from "../package/ProductContainer";
import {useNavigate} from "react-router";
import AuthService from "../services/auth/auth_service";
import ClockLoader from "react-spinners/ClockLoader";
import {ToastContainer} from "react-toastify";

export default function Package() {
  sessionStorage.removeItem('scroll')
  const [activeTab, setActiveTab] = React.useState("html");

  const navigate = useNavigate()
  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);


   const data = [
    {
      label: "View1",
      value: "html",
      desc: <View1 productImages={productImages} />
    },
    {
      label: "View2",
      value: "react",
      desc: <View2 callouts={productImages} />
    },
    /*{
      label: "Vue",
      value: "vue",
      desc: <View3/>
    },*/

  ];


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    if (!hasMore || loadingMore) {
      return;
    }

    setLoadingMore(true);

    /*AuthService.loadProductsByCategoryAndSubCategory("All", "All", page)
      .then((data) => {
        if (page === 1) {

          setProductImages(data.data.results);
        } else {
          setProductImages((prevImages) => [...prevImages, ...data.data.results]);
        }

        if (!data.data.next) {
          setHasMore(false);
        }

        setPage(page + 1);
        setLoadingMore(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoadingMore(false);
      });
  };*/

      AuthService.loadProductsByCategoryAndSubCategory("All", "All", page)
  .then((data) => {
    if (page === 1) {
      const formattedResults = data.data.results.map((product) => ({
        ...product,
        price: product.price.toLocaleString(),
      }));
      setProductImages(formattedResults);
    } else {
      const formattedNewResults = data.data.results.map((product) => ({
        ...product,
        price: product.price.toLocaleString(),
      }));
      setProductImages((prevImages) => [...prevImages, ...formattedNewResults]);
    }

    if (!data.data.next) {
      setHasMore(false);
    }

    setPage(page + 1);
    setLoadingMore(false);
    setLoading(false);
  })
  .catch((error) => {
    console.error("Error fetching data:", error);
    setLoadingMore(false);
  });
};


  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 100 &&
      !loadingMore &&
      hasMore
    ) {
      fetchData();
    }
  }, [loadingMore, hasMore]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);



    /*const handleClick = () => {
      const scrollPosition = window.scrollY;
      console.log('Scroll Position:', scrollPosition);
      sessionStorage.setItem('scroll', scrollPosition)
    }
*/
  const [loc, setLoc] = useState(localStorage.getItem('selected-theme'))
  useEffect(()=>{
    setLoc(localStorage.getItem('selected-theme'))
  })

  return (
    <Tabs
          onContextMenu={(e) => {
                          e.preventDefault(); // Prevent the default context menu
                          return false;
                        }}
        value={activeTab} className={'lg:mt-4 mt-2 '}>
      <ToastContainer/>

      <TabsHeader
        className="rounded-none sm:mt-2  lg:mt-5 border-b border-blue-gray-50 bg-transparent p-0 fixed bg-white z-50 w-full"
        indicatorProps={{
          className:
            "bg-transparent border-b-2 border-gray-900 shadow-none rounded-none",
        }}
        style={{backgroundColor: loc==='light'?'hsl(0, 0%, 99%)':'#1D2521'}}
      >
        {data.map(({ label, value }) => (
          <Tab
            key={value}
            value={value}
            onClick={() => setActiveTab(value)}
            className={activeTab === value ? "text-green-600 font-bold" : ""}
          >
            {label}
          </Tab>
        ))}
      </TabsHeader>
      <TabsBody className={'mt-6'}>
        {data.map(({ value, desc }) => (
          <TabPanel key={value} value={value}>
            {desc}

            {loadingMore && (
    <div className="flex justify-center mt-4">
      <ClockLoader color="#3B82F6" size={30} />
    </div>
  )}
          </TabPanel>
        ))}

      </TabsBody>



    </Tabs>
  );
}